<template>
  <div class="virtual-coupon-wrapper">
    <div class="bg">
      <img :src="H5Bg || info.bgImg" alt="" />
    </div>
    <div class="content">
      <h1 class="title">{{ info.title }}</h1>
      <p class="desc">{{ info.content }}</p>
    </div>
  </div>
</template>
<script>
import H5Bg from '@/assets/images/didi/coupon/banner.png';

export default {
  name: 'VirtualCoupon',
  props: {
    couponTags: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    info() {
      return this.couponTags[0];
    },
  },
  data() {
    this.H5Bg = H5Bg;
    return {};
  },
  mounted() {
    this.$trackEvent({
      eventId: 'sailing_c_x_outside_shop_top_cupon_sw',
      eventLabel: 'Web商家页头部优惠券模块实际曝光',
      attrs: {
        shop_id: this.$route.params.storeId,
      },
    });
  },
};
</script>
<style lang="scss" scoped>
.virtual-coupon-wrapper {
  position: relative;
  margin: 0 rem(24);
  .bg {
    font-size: 0;
    img {
      width: 100%;
      object-fit: cover;
    }
  }
  .content {
    position: absolute;
    left: rem(36);
    bottom: rem(24);
  }
  .title {
    font-family: DiDiSans-Pro-Medium;
    font-size: rem(30);
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 500;
  }
  .desc {
    margin-top: rem(8);
    font-family: DiDiSans-Pro-Bold;
    font-size: rem(72);
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 700;
  }
}
@media screen and (min-width: 768px) {
  .virtual-coupon-wrapper {
    .content {
      bottom: rem(16);
    }
  }
}
</style>
